import styled from "styled-components";

export const CompanyButtonContainer = styled.div.attrs({
})`
    width: 100%;
    display: flex;
    gap: 16px;
    border-top: 1px solid ${p => p.theme.palette.colors.borderSoft};
    padding-top: 20px;
    margin-top: 8px;

    @media (max-width: 767px) {
        flex-direction: column-reverse;
    }

`;

export const CloseContainer = styled.div.attrs({
})`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

export const ModalContainer = styled.div.attrs({
})`
    width: 100%;
`;

export const InputContainer = styled.div.attrs({
})`
    margin-top: 24px;
    padding: 24px 0;
    
`;

export const TextLabel = styled.div.attrs({
})`
    font-size: 13px;
    line-height: 1.6;
    font-weight: 500;
    letter-spacing: -0.01em;
    color: ${props => props.theme.palette.colors.muted};
    background: ${props => props.theme.palette.colors.buttonGhost};
    border: 1px solid ${props => props.theme.palette.colors.borderSoft};
    border-radius: 18px;
    padding: 16px 18px;
`;
